import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumVesselAvailability implements BaseEnumType {
  private static allValues: EnumVesselAvailability[] = []; // make sure this is top-most
  
  public static available = new EnumVesselAvailability(0, "Available", "enum_vessel_availability_available");
  public static inUse = new EnumVesselAvailability(1, "InUse", "enum_vessel_availability_in_use");
  public static requiresMaintenance = new EnumVesselAvailability(2, "RequiresMaintenance", "enum_vessel_availability_requires_maintenance");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumVesselAvailability.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isAvailable() { return this === EnumVesselAvailability.available; }
  public isInUse() { return this === EnumVesselAvailability.inUse; }
  public isRequiresMaintenance() { return this === EnumVesselAvailability.requiresMaintenance; }

  public static getValues(): readonly EnumVesselAvailability[] {
    return EnumVesselAvailability.allValues;
  }

  public static getValuesExcept0(): readonly EnumVesselAvailability[] {
    return EnumVesselAvailability.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumVesselAvailability {
    const found = EnumVesselAvailability.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumVesselAvailability - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumVesselAvailability): EnumVesselAvailability {
    const found = name ? EnumVesselAvailability.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumVesselAvailability - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumVesselAvailability>): boolean {
    return this.key === other?.key;
  }
}